import { defaultApiState } from '../api.state';

export const newsletterState = {
  apiState: {
    getNewsletters: defaultApiState,
    getNewsletter: defaultApiState,
    deleteNewsletter: defaultApiState,
    addNewsletter: defaultApiState,
    updateNewsletter: defaultApiState,
  },
  newsletters: [],
  newsletter: undefined,
};
